import React, { useContext } from "react";
import "../styles/ClientPicker.css";
import { Link } from "react-router-dom";
import { ClientContext } from "../contexts/ClientContext";

const ClientPicker = () => {
  const { clients, setCurrentClient } = useContext(ClientContext);

  /*  
    Rendering each one as a link with the id on it
    
    I am not sure if we actually need to include the id or if
    we can just pass the data into the themeeditor page. But the 
    theme editor needs to know which theme to access
  */
  const renderClientPickerItems = clients.map((client) => {
    return (
      <Link
        to={`/themeeditor/${client.clientid}/color`}
        className="client-picker-item"
        key={client.clientid}
        onClick={() => setCurrentClient(client)}>
        {client.name}
      </Link>
    );
  });

  return (
    <div className="client-picker">
      <h2 className="client-picker-header">Clients</h2>
      <div className="client-picker-grid">{renderClientPickerItems}</div>
    </div>
  );
};

export default ClientPicker;
